import * as React from 'react';
import { ArticleHeading3, ArticleParagraph2, Button } from '@cian/ui-kit';
import { NewBuildingCard } from '../../components/NewBuildingCard';
import { Link } from '../../components/Link';
import { INewBuilding } from '../../types/newBuldings';
import { NEWBUILDING_CARD_SEE_ALL_BUTTON_LINK } from '../Map/constants';
import { PromoBlockContainer } from '../PromoBlock';
import { SubwayInfo } from '../SubwayInfo';
import { BalloonImage } from '../BalloonImage';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { TSPTheme } from '../../types/specialProjects/themes';

interface IMapBalloonProps {
  newBuilding: INewBuilding;
  callbackButtonTheme?: TSPTheme;
}

export function NewBuildingMapBalloon({ newBuilding, callbackButtonTheme }: IMapBalloonProps) {
  const title = <ArticleHeading3>{newBuilding.title}</ArticleHeading3>;
  const finishLabel = newBuilding.finishLabel ? <ArticleParagraph2>{newBuilding.finishLabel}</ArticleParagraph2> : null;
  const address = <ArticleParagraph2>{newBuilding.address}</ArticleParagraph2>;
  const publicUrl = newBuilding.publicUrl;
  const subwayInfo = <SubwayInfo subwayInfo={newBuilding.subwayInfo} />;
  const promo = <PromoBlockContainer promos={newBuilding.promoList} url={publicUrl} />;

  return (
    <NewBuildingCard
      hasClose
      size="XS"
      isReliable={newBuilding.isReliable}
      promo={promo}
      image={<BalloonImage imageUrl={newBuilding.image} newBuildingName={newBuilding.title} />}
      title={title}
      url={publicUrl}
      finishLabel={finishLabel}
      subwayInfo={subwayInfo}
      address={address}
      apartmentsInSearch={
        newBuilding.searchList ? (
          <Link id={NEWBUILDING_CARD_SEE_ALL_BUTTON_LINK} url={newBuilding.searchList} text="Квартиры в продаже" />
        ) : null
      }
      showPhone={
        newBuilding.phoneNumber ? (
          <SPThemeWrapper theme={callbackButtonTheme}>
            <Button id={`${newBuilding.id}-phone`} size="XS" fullWidth>
              {getShowPhoneButtonText(newBuilding.isKpn)}
            </Button>
          </SPThemeWrapper>
        ) : null
      }
    />
  );
}

function getShowPhoneButtonText(isKpn: boolean) {
  return isKpn ? 'Консультант Циан' : 'Показать контакты';
}
